import { useFadeIn } from "../../hooks/useFadeIn";

export const Hero = () => {
  const ref = useFadeIn<HTMLElement>();

  return (
    <section ref={ref} className="hero reveal" id="home">
      <div className="container hero__grid">
        <div className="hero__main">
          <div className="hero__prefix">
            <span className="prefix__sigil">$</span> whoami --verbose
          </div>

          <h1 className="hero__name">
            Suman / Pokharel<span className="dot dot--inline">.</span>
            <span className="caret" aria-hidden="true" />
          </h1>

          <pre className="hero__obj" aria-hidden="true">
{`const `}<span className="kw">suman</span>{` = {
  `}<span className="key">role</span>{`: `}<span className="str">"frontend engineer"</span>{`,
  `}<span className="key">location</span>{`: `}<span className="str">"Kathmandu, NP"</span>{`,
  `}<span className="key">focus</span>{`: `}<span className="str">"react + typescript"</span>{`,
  `}<span className="key">available</span>{`: `}<span className="bool">true</span>{`,
};`}
          </pre>

          <p className="hero__tagline">
            I'm a frontend engineer with 5 years building complex React and
            TypeScript apps — real-time state, large-data performance, and
            interfaces that feel handmade.
          </p>

          <div className="hero__cta">
            <a href="#projects" className="btn btn--primary">./view-projects.sh →</a>
            <a href="#contact"  className="btn btn--ghost">cat ./contact.txt</a>
          </div>
        </div>

        <aside className="status">
          <div className="status__head">
            <span>system.status</span>
            <span className="status__live">
              <span className="dot dot--green" aria-hidden="true" /> live
            </span>
          </div>
          <ul className="status__list">
            <li><span className="k">uptime:</span> 412 days</li>
            <li><span className="k">commits.this.week:</span> 47</li>
            <li><span className="k">coffee.consumed:</span> 1,283 cups</li>
            <li><span className="k">last.deploy:</span> 2h ago</li>
            <li>
              <span className="k">currently.reading:</span>
              <div className="status__sub">"Designing Data-Intensive Apps"</div>
            </li>
          </ul>
          <div className="status__np">
            <div className="status__nphead">NOW PLAYING</div>
            <div className="status__nptitle">♪ Lo-fi beats to ship to</div>
            <div className="progress"><div className="progress__fill" /></div>
          </div>
        </aside>
      </div>
    </section>
  );
};
